var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTeamworkCollaboration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 20,
    fill: "url(#paint0_linear_658_3839)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.148 77.0985L60.2422 50.3485C59.8635 50.2146 59.4582 50.1736 59.0604 50.229C58.6625 50.2844 58.2838 50.4346 57.9561 50.6669C57.6284 50.8991 57.3613 51.2067 57.1772 51.5637C56.9932 51.9207 56.8976 52.3167 56.8984 52.7184V126.281C56.8984 126.946 57.1627 127.584 57.633 128.054C58.1033 128.524 58.7411 128.789 59.4063 128.789C60.0714 128.789 60.7092 128.524 61.1795 128.054C61.6499 127.584 61.9141 126.946 61.9141 126.281V108.003L137.148 81.8383C137.641 81.6677 138.069 81.3478 138.371 80.9231C138.673 80.4983 138.836 79.9898 138.836 79.4684C138.836 78.9469 138.673 78.4385 138.371 78.0137C138.069 77.589 137.641 77.2691 137.148 77.0985ZM61.9141 102.691V56.246L128.68 79.4684L61.9141 102.691Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_658_3839",
    x1: -36.506,
    y1: 143.832,
    x2: 228.472,
    y2: 6.30687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DA5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamworkCollaboration);
export default __webpack_public_path__ + "static/media/icon_teamwork_collaboration.3e238b9bd49adff229285d1fbe30498b.svg";
export { ForwardRef as ReactComponent };